import React, { useRef } from "react";
import {
	Box,
	Button,
	Chip,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";

import Header from "../components/Header";
import Footer from "../components/Footer";
import FormularioNichos from "../niches/pages/components/FormularioNichos";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";

const infos = [
	{
		value: "24h",
		label: "Primeira análise",
	},
	{
		value: "100%",
		label: "Digital",
	},
	{
		value: "CPF/IR",
		label: "Foco fiscal",
	},
];

const cards = [
	{
		number: "01",
		tag: "URGÊNCIA MÁXIMA",
		title: "Seu dinheiro foi bloqueado na conta?",
		description: "Bloqueio pode ter origem fiscal, cadastral ou judicial. Antes de mandar documentos sem orientação, entenda o motivo real.",
		color: "#FF445C",
	},
	{
		number: "02",
		tag: "BANCO TRAVADO",
		title: "Sua conta bancária foi bloqueada ou limitada?",
		description: "Bancos pedem comprovação de origem dos valores. Uma resposta incompleta pode piorar a análise.",
		color: "#C000FF",
	},
	{
		number: "03",
		tag: "CPF IRREGULAR",
		title: "Seu CPF está travando sua vida financeira?",
		description: "CPF irregular costuma aparecer quando já atrapalhou crédito, conta, financiamento ou investimento.",
		color: "#00D9FF",
	},
	{
		number: "04",
		tag: "IR SOLICITADO",
		title: "O banco pediu seu Imposto de Renda?",
		description: "Antes de enviar qualquer documento, veja se sua declaração está compatível com os valores movimentados.",
		color: "#00FF88",
	},
	{
		number: "05",
		tag: "RECEITA FEDERAL",
		title: "Recebeu uma notificação da Receita Federal?",
		description: "Notificação não é condenação, mas exige resposta correta e dentro do prazo.",
		color: "#FFA500",
	},
	{
		number: "06",
		tag: "MALHA FINA",
		title: "Seu Imposto de Renda caiu na malha fina?",
		description: "Malha fina pode envolver rendimento omitido, despesa sem comprovação ou movimentação incompatível.",
		color: "#FF0077",
	},
	{
		number: "07",
		tag: "IR ATRASADO",
		title: "Está com o Imposto de Renda atrasado?",
		description: "Regularizar anos anteriores tem solução. O ideal é calcular o custo real antes de qualquer ação.",
		color: "#7C4DFF",
	},
	{
		number: "08",
		tag: "DÍVIDA FISCAL",
		title: "Tem dívida ou multa com a Receita Federal?",
		description: "Antes de pagar, confira se o valor está correto, se cabe parcelamento, revisão ou contestação.",
		color: "#FFB800",
	},
	{
		number: "09",
		tag: "PROTESTO",
		title: "Recebeu protesto por dívida de imposto?",
		description: "Dívida fiscal em cartório pode travar crédito, conta e contratos, mas existe caminho de regularização.",
		color: "#FF5E3A",
	},
	{
		number: "10",
		tag: "RISCO JUDICIAL",
		title: "Está com medo de penhora ou bloqueio judicial?",
		description: "O risco cresce quando a dívida avança sem resposta. Agir antes da etapa judicial protege conta, CPF e patrimônio.",
		color: "#FF1744",
	},
];

export default function RegularizacaoFiscal() {
	const secaoRef = useRef(null);

	const irParaSecao = () => {
		secaoRef.current.scrollIntoView({
			behavior: "smooth",
		});
	};
	return (
		<>
			<Header />
			<Box
				sx={{
					width: "100%",
					position: "relative",
					overflow: "hidden",
					backgroundColor: "#172B3D",
					display: "flex",
					justifyContent: "center",
					padding: "100px 40px",
					backgroundImage: `
            linear-gradient(rgba(255,255,255,.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,.04) 1px, transparent 1px)
        `,
					backgroundSize: "40px 40px",
				}}
			>
				{/* Glow esquerdo */}
				<Box
					sx={{
						position: "absolute",
						width: "600px",
						height: "600px",
						background:
							"radial-gradient(circle, rgba(0,255,136,0.18), transparent 70%)",
						top: "-200px",
						left: "-200px",
						pointerEvents: "none",
					}}
				/>

				{/* Glow direito */}
				<Box
					sx={{
						position: "absolute",
						width: "600px",
						height: "600px",
						background:
							"radial-gradient(circle, rgba(138,46,255,0.16), transparent 70%)",
						bottom: "-250px",
						right: "-200px",
						pointerEvents: "none",
					}}
				/>

				<Box
					sx={{
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",
						margin: "0 auto",
						position: "relative",
						zIndex: 1,
						display: "flex",
						flexDirection: {
							xs: "column",
							lg: "row",
						},
						alignItems: "center",
						justifyContent: "center",
						gap: {
							xs: "50px",
							lg: "80px",
						},
						px: {
							xs: "20px",
							md: "40px",
						},
					}}
				>
					<Box
						sx={{
							flex: 1,
							width: "100%",
							display: "flex",
							flexDirection: "column",
							alignItems: {
								xs: "center",
								lg: "center",
							},
							textAlign: {
								xs: "center",
								lg: "center",
							},
						}}
					>
						<Typography
							sx={{
								color: "#00FF88",
								fontSize: "13px",
								fontWeight: 800,
								letterSpacing: "3px",
								textTransform: "uppercase",
								mb: "20px",
							}}
						>
							Regularização Fiscal / ContBlack
						</Typography>

						<Typography
							sx={{
								color: "#FFF",
								fontWeight: 900,
								fontSize: {
									xs: "34px",
									sm: "44px",
									md: "58px",
								},
								lineHeight: 0.95,
								maxWidth: "700px",
								mb: "28px",
							}}
						>
							Conta bloqueada,
							<br />
							CPF irregular ou
							<br />
							malha fina?
							<br />
							Resolva com
							<br />
							estratégia fiscal.
						</Typography>

						<Typography
							sx={{
								color: "#C6D0DA",
								fontSize: {
									xs: "17px",
									md: "20px",
								},
								lineHeight: 1.7,
								maxWidth: "620px",
								mb: "40px",
							}}
						>
							A ContBlack ajuda você a entender o problema,
							organizar documentos e regularizar sua situação
							com banco, CPF, Receita Federal e Imposto de
							Renda de forma digital e sem juridiquês.
						</Typography>

						<Button
							sx={{
								background:
									"linear-gradient(90deg, #00FF88, #00D66E)",
								color: "#02111F",
								padding: {
									xs: "16px 28px",
									md: "18px 34px",
								},
								borderRadius: "50px",
								fontWeight: 900,
								fontSize: "17px",
								textTransform: "none",
								boxShadow:
									"0 12px 35px rgba(0,255,136,0.35)",
								transition: "0.3s",
								mb: "50px",
								"&:hover": {
									transform: "translateY(-3px)",
									boxShadow:
										"0 18px 45px rgba(0,255,136,0.5)",
								},
							}}
							onClick={irParaSecao}
						>
							Regularizar minha situação →
						</Button>

						<Box
							sx={{
								width: "100%",
								display: "flex",
								flexWrap: "wrap",
								gap: "18px",
								justifyContent: {
									xs: "center",
									lg: "center",
								},
							}}
						>
							{infos.map((item) => (
								<Box
									key={item.value}
									sx={{
										flex: "1 1 220px",
										maxWidth: "260px",
										minHeight: "140px",
										background:
											"linear-gradient(180deg,#203449,#172634)",
										border: "1px solid #31475C",
										borderRadius: "22px",
										padding: "24px",
										transition: "0.3s",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										"&:hover": {
											transform: "translateY(-6px)",
											borderColor: "#00FF88",
											boxShadow:
												"0 12px 35px rgba(0,255,136,0.15)",
										},
									}}
								>
									<Typography
										sx={{
											color: "#00FF88",
											fontWeight: 900,
											fontSize: "26px",
											mb: "8px",
										}}
									>
										{item.value}
									</Typography>

									<Typography
										sx={{
											color: "#B8C3CF",
											fontWeight: 600,
											lineHeight: 1.5,
										}}
									>
										{item.label}
									</Typography>
								</Box>
							))}
						</Box>
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					width: "100%",
					backgroundColor: "#172b3d",
					padding: "80px 40px",
					display: "flex",
					justifyContent: "center",
				}}
			>
				<Box
					sx={{
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",
					}}
				>
					<Typography
						sx={{
							color: "#b3a38a",
							fontSize: "18px",
							letterSpacing: "3px",
							fontWeight: 700,
							marginBottom: "10px",
						}}
					>
						URGÊNCIA / MALHA FINA
					</Typography>

					<Typography
						sx={{
							color: "#ffffff",
							fontSize: {
								xs: "36px",
								md: "58px"
							},
							fontWeight: 900,
							lineHeight: 1,
							marginBottom: "25px",
							maxWidth: "700px"
						}}
					>
						Qual desses problemas está te tirando o sono agora?
					</Typography>

					<Typography
						sx={{
							color: "#c0c8d0",
							fontSize: "18px",
							lineHeight: 1.6,
							maxWidth: "700px",
							marginBottom: "50px",
						}}
					>
						 Clique no que está acontecendo com você. A ContBlack resolve rápido, sem burocracia e sem julgamento.
					</Typography>

					<Box
						sx={{
							display: "grid",
							gridTemplateColumns: {
								xs: "1fr",
								md: "repeat(3, 1fr)"
							},
							gap: "20px",
						}}
					>
						{cards.map((card, index) => (
							<Box
								key={index}
								sx={{
									backgroundColor: "#233448",
									borderRadius: "22px",
									padding: "22px",
									borderTop: `3px solid ${card.color}`,
									position: "relative",
									minHeight: "220px",
									transition: "0.3s",
									cursor: "pointer",
									"&:hover": {
										transform: "translateY(-8px)",
										boxShadow: `0 15px 30px ${card.color}40`,
									}
								}}
							>
								<Box
									sx={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "15px",
									}}
								>
									<Typography
										sx={{
											fontSize: "42px",
											fontWeight: 900,
											color: "#44576d",
											lineHeight: 1,
										}}
									>
										{card.number}
									</Typography>

									<Chip
										label={card.tag}
										sx={{
											backgroundColor: "#1b2b3d",
											color: "#fff",
											fontSize: "10px",
											fontWeight: 700,
											height: "26px",
										}}
									/>
								</Box>

								<Typography
									sx={{
										color: "#fff",
										fontSize: "28px",
										fontWeight: 800,
										lineHeight: 1.1,
										marginBottom: "15px",
									}}
								>
									{card.title}
								</Typography>

								<Typography
									sx={{
										color: "#c4ced8",
										fontSize: "16px",
										lineHeight: 1.5,
									}}
								>
									{card.description}
								</Typography>
							</Box>
						))}
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					width: "100%",
					backgroundColor: "#020b17",
					display: "flex",
					justifyContent: "center",
					padding: "80px 40px",
				}}
			>
				<Box
					sx={{
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",
						backgroundColor: "#203449",
						borderRadius: "30px",
						border: "1px solid #31485f",
						padding: {
							xs: "35px 25px",
							md: "50px 60px",
						},
						display: "flex",
						flexDirection: {
							xs: "column",
							md: "row",
						},
						alignItems: "center",
						justifyContent: "space-between",
						gap: "30px",
					}}
				>
					{/* Texto */}
					<Box
						sx={{
							maxWidth: "850px",
						}}
					>

						<Typography
							sx={{
								color: "#ffffff",
								fontSize: {
									xs: "24px",
									md: "30px",
								},
								fontWeight: 900,
								lineHeight: 1,
								marginBottom: "25px",
								maxWidth: "900px",
							}}
						>
							Não sabe por onde começar? Comece pelo diagnóstico.
						</Typography>

						<Typography
							sx={{
								color: "#c3cbd4",
								fontSize: "18px",
								lineHeight: 1.7,
								maxWidth: "70%",
							}}
						>
							A primeira conversa serve para entender sua urgência, risco e quais documentos fazem sentido antes de qualquer resposta ao banco ou à Receita.
						</Typography>
					</Box>

					{/* Botão */}
					<Box
						sx={{
							minWidth: {
								xs: "100%",
								md: "auto",
							},
							display: "flex",
							justifyContent: "center",
						}}
					>
						<Box
							sx={{
								backgroundColor: "#00ff8a",
								color: "#02111f",
								fontWeight: 800,
								fontSize: "18px",
								padding: "20px 40px",
								borderRadius: "50px",
								cursor: "pointer",
								display: "flex",
								alignItems: "center",
								gap: "12px",
								transition: "0.3s",
								boxShadow: "0 0 25px rgba(0,255,138,0.45)",
								"&:hover": {
									transform: "translateY(-3px)",
									boxShadow: "0 0 35px rgba(0,255,138,0.7)",
								},
							}}
							onClick={irParaSecao}

						>
							Solicitar
							<span style={{ fontSize: "20px" }}>
								→
							</span>
						</Box>
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					width: "100%",
					backgroundColor: "#071524",
					display: "flex",
					justifyContent: "center",
					padding: "90px 40px",
				}}
			>
				<Box
					sx={{
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",

					}}
				>
					{/* Título */}
					<Box
						sx={{
							textAlign: "center",
							marginBottom: "60px",
						}}
					>
						<Typography
							sx={{
								color: "#00d9ff",
								fontSize: "16px",
								fontWeight: 800,
								letterSpacing: "4px",
								textTransform: "uppercase",
								marginBottom: "15px",
							}}
						>
							COMPARATIVO TÉCNICO
						</Typography>

						<Typography
							sx={{
								color: "#ffffff",
								fontSize: {
									xs: "36px",
									md: "64px",
								},
								fontWeight: 900,
								lineHeight: 1,
								maxWidth: "900px",
								margin: "0 auto 25px auto",
							}}
						>
							Você não precisa entender de imposto. A ContBlack entende por você.
						</Typography>

						<Typography
							sx={{
								color: "#b7c2cf",
								fontSize: "18px",
								lineHeight: 1.6,
								maxWidth: "750px",
								margin: "0 auto",
							}}
						>
							Diagnóstico rápido, plano de regularização claro e acompanhamento até o problema ser resolvido sem juridiquês, sem surpresa no final.
						</Typography>
					</Box>


					{/* Cards */}
					<Box
						sx={{
							width: "100%",
							display: "flex",
							flexWrap: "wrap",
							gap: "22px",
							justifyContent: "center",
						}}
					>
						{[
							{
								number: "01",
								title: "Diagnóstico sem juridiquês",
								text: "Você explica o que aconteceu: conta bloqueada, banco pedindo documento, CPF irregular, malha fina ou notificação.",
							},
							{
								number: "02",
								title: "Leitura fiscal completa",
								text: "A ContBlack identifica a origem real do problema e cruza informações de IR, CPF, Receita, banco e pendências abertas.",
							},
							{
								number: "03",
								title: "Plano de regularização",
								text: "Você recebe o caminho mais seguro: corrigir declaração, responder intimação, parcelar, revisar cobrança ou organizar documentos.",
							},
							{
								number: "04",
								title: "Execução e acompanhamento",
								text: "O time acompanha até o fim, com atualização clara em cada etapa e atendimento digital.",
							},
						].map((card, index) => (
							<Box
								key={index}
								sx={{
									backgroundColor: "#203449",
									border: "1px solid #31475c",
									borderRadius: "28px",
									padding: "28px",
									display: "flex",
									flexDirection: "column",
									transition: "0.3s",
									cursor: "default",
									minWidth: "280px",

									// Responsividade
									flex: {
										xs: "1 1 100%",
										sm: "1 1 calc(50% - 11px)",
										lg: "1 1 calc(25% - 17px)",
									},

									maxWidth: {
										xs: "100%",
										sm: "calc(50% - 11px)",
										lg: "calc(25% - 17px)",
									},

									minHeight: {
										xs: "auto",
										lg: "290px",
									},

									"&:hover": {
										transform: "translateY(-8px)",
										boxShadow:
											"0 15px 35px rgba(0, 255, 136, 0.18)",
										borderColor: "#00ff88",
									},
								}}
							>
								{/* Número */}
								<Box
									sx={{
										width: "42px",
										height: "42px",
										backgroundColor: "#00ff88",
										color: "#02111f",
										borderRadius: "14px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										fontWeight: 900,
										fontSize: "16px",
										marginBottom: "30px",
										boxShadow: "0 0 20px rgba(0,255,136,0.35)",
									}}
								>
									{card.number}
								</Box>

								<Typography
									sx={{
										color: "#ffffff",
										fontSize: {
											xs: "15px",
											md: "20px",
										},
										fontWeight: 800,
										lineHeight: 1.2,
										marginBottom: "15px",
									}}
								>
									{card.title}
								</Typography>

								<Typography
									sx={{
										color: "#b7c2cf",
										fontSize: {
											xs: "13px",
											md: "13px",
										},
										lineHeight: 1.6,
									}}
								>
									{card.text}
								</Typography>
							</Box>
						))}
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					width: "100%",
					backgroundColor: "#203449",
					display: "flex",
					justifyContent: "center",
					padding: "90px 40px",
				}}
			>
				<Box
					sx={{
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",
						display: "flex",
						flexDirection: {
							xs: "column",
							lg: "row",
						},
						justifyContent: "space-between",
						gap: "60px",
						alignItems: "flex-start",
					}}
				>
					{/* Conteúdo esquerdo */}
					<Box
						sx={{
							maxWidth: "500px",
						}}
					>
						<Typography
							sx={{
								color: "#ff0099",
								fontSize: "15px",
								fontWeight: 800,
								letterSpacing: "3px",
								textTransform: "uppercase",
								marginBottom: "15px",
							}}
						>
							Antes de agir sozinho
						</Typography>

						<Typography
							sx={{
								color: "#ffffff",
								fontSize: {
									xs: "20px",
									md: "48px",
								},
								fontWeight: 900,
								lineHeight: 0.95,
								marginBottom: "30px",
							}}
						>
							A pressa pode sair mais cara que o problema.
						</Typography>

						<Typography
							sx={{
								color: "#d4dbe3",
								fontSize: "20px",
								lineHeight: 1.7,
							}}
						>
							Muita gente tenta resolver sozinha e piora a situação sem querer. Antes de parcelar, contestar ou ignorar qualquer notificação da Receita, entenda exatamente o que está em jogo.
						</Typography>
					</Box>


					{/* Lista de avisos */}
					<Box
						sx={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: "18px",
							width: "100%",
						}}
					>
						{[
							"Não responda ao banco ou à Receita no impulso. Documento errado pode gerar novas perguntas.",
							"Malha fina, CPF irregular e conta bloqueada precisam de diagnóstico antes de qualquer pagamento.",
							"O objetivo é resolver com segurança, reduzir risco e evitar que o problema cresça.",
							"A ContBlack organiza o passado fiscal para você voltar a operar com tranquilidade.",
						].map((text, index) => (
							<Box
								key={index}
								sx={{
									backgroundColor: "#26394d",
									border: "1px solid #3a4f63",
									borderRadius: "24px",
									minHeight: "92px",
									padding: "0 28px",
									display: "flex",
									alignItems: "center",
									gap: "18px",
									transition: "0.3s",

									"&:hover": {
										borderColor: "#ff0099",
										boxShadow: "0 0 25px rgba(255,0,153,0.25)",
										transform: "translateX(8px)",
									},
								}}
							>
								{/* Número */}
								<Box
									sx={{
										minWidth: "42px",
										width: "42px",
										height: "42px",
										borderRadius: "14px",
										border: "1px solid #ff0099",
										backgroundColor: "rgba(255,0,153,0.12)",
										color: "#ff0099",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										fontWeight: 900,
										fontSize: "16px",
									}}
								>
									{String(index + 1).padStart(2, "0")}
								</Box>


								<Typography
									sx={{
										color: "#ffffff",
										fontSize: {
											xs: "14px",
											md: "15px",
										},
										lineHeight: 1.6,
										fontWeight: 500,
									}}
								>
									{text}
								</Typography>
							</Box>
						))}
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					width: "100%",
					backgroundColor: "#020b17",
					display: "flex",
					justifyContent: "center",
					padding: "90px 40px",
				}}
			>
				<Box
					sx={{
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					<Typography
						sx={{
							color: "#00ff88",
							fontSize: "15px",
							fontWeight: 800,
							letterSpacing: "4px",
							textTransform: "uppercase",
							marginBottom: "15px",
						}}
					>
						PERGUNTAS FREQUENTES
					</Typography>

					<Typography
						sx={{
							color: "#fff",
							fontSize: {
								xs: "42px",
								md: "68px",
							},
							fontWeight: 900,
							lineHeight: 0.95,
							textAlign: "center",
							maxWidth: "700px",
							marginBottom: "50px",
						}}
					>
						Dúvidas sobre regularização fiscal
					</Typography>

					<Box
						sx={{
							width: "100%",
							maxWidth: "900px",
							backgroundColor: "#203449",
							borderRadius: "30px",
							padding: "15px 25px",
							border: "1px solid #31475c",
						}}
					>
						{[
							{
								pergunta:
									"Quanto tempo leva para regularizar minha situação?",
								resposta:
									"O prazo depende do tipo de pendência, mas após o diagnóstico é possível estimar o caminho e o tempo necessário para a regularização.",
							},
							{
								pergunta:
									"Preciso comparecer presencialmente?",
								resposta:
									"Não. Todo o atendimento pode ser realizado de forma digital, com envio de documentos e acompanhamento remoto.",
							},
							{
								pergunta:
									"Quem caiu na malha fina precisa pagar multa?",
								resposta:
									"Nem sempre. Cada caso deve ser analisado para entender a origem da pendência e qual é a melhor estratégia.",
							},
							{
								pergunta:
									"Tenho IR atrasado de vários anos. Tem solução?",
								resposta:
									"Sim. É possível organizar as declarações pendentes, corrigir informações e regularizar a situação junto à Receita.",
							},
						].map((item, index) => (
							<Accordion
								key={index}
								disableGutters
								elevation={0}
								sx={{
									backgroundColor: "transparent",
									color: "#fff",
									boxShadow: "none",
									"&::before": {
										display: "none",
									},
								}}
							>
								<AccordionSummary
									expandIcon={
										<Typography
											sx={{
												color: "#00ff88",
												fontWeight: 900,
												fontSize: "22px",
											}}
										>
											+
										</Typography>
									}
									sx={{
										padding: "0",
										minHeight: "65px",
										borderBottom:
											index !== 3
												? "1px solid #31475c"
												: "none",
									}}
								>
									<Typography
										sx={{
											fontWeight: 700,
											fontSize: "18px",
										}}
									>
										{item.pergunta}
									</Typography>
								</AccordionSummary>

								<AccordionDetails
									sx={{
										padding: "0 0 20px 0",
									}}
								>
									<Typography
										sx={{
											color: "#c4ced8",
											lineHeight: 1.6,
										}}
									>
										{item.resposta}
									</Typography>
								</AccordionDetails>
							</Accordion>
						))}
					</Box>
				</Box>
			</Box>
			<div ref={secaoRef}>
				<FormularioNichos nicho={"Regularizacao"} />
			</div>
			<Box
				sx={{
					width: "100%",
					display: "flex",
					justifyContent: "center",
					backgroundColor: "#1b3145",
					padding: "100px 40px",
					position: "relative",
					overflow: "hidden",

					backgroundImage: `
            linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)
        `,
					backgroundSize: "40px 40px",
				}}
			>
				{/* brilho central */}
				<Box
					sx={{
						position: "absolute",
						width: "600px",
						height: "600px",
						background:
							"radial-gradient(circle, rgba(0,255,136,0.18), transparent 70%)",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						pointerEvents: "none",
					}}
				/>

				<Box
					sx={{
						position: "relative",
						zIndex: 1,
						width: "100%",
						maxWidth: window.innerWidth < 900 ? "100%" : "70%",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						textAlign: "center",
					}}
				>
					<Typography
						sx={{
							color: "#fff",
							fontSize: {
								xs: "42px",
								md: "72px",
							},
							fontWeight: 900,
							lineHeight: 0.95,
							maxWidth: "850px",
							marginBottom: "30px",
						}}
					>
						Regularize antes que isso vire um problema maior.
					</Typography>

					<Typography
						sx={{
							color: "#c6d0d9",
							fontSize: "20px",
							lineHeight: 1.7,
							maxWidth: "70%",
							marginBottom: "45px",
						}}
					>
						Seu CPF, sua conta bancária e sua rotina financeira não precisam ficar parados por falta de orientação fiscal.
					</Typography>


					<Box
						sx={{
							display: "flex",
							gap: "18px",
							flexDirection: {
								xs: "column",
								sm: "row",
							},
							width: {
								xs: "100%",
								sm: "auto",
							},
						}}
					>
						<Box
							sx={{
								backgroundColor: "#00ff88",
								color: "#02111f",
								padding: "18px 30px",
								borderRadius: "50px",
								fontWeight: 800,
								cursor: "pointer",
								boxShadow:
									"0 0 25px rgba(0,255,136,0.35)",
								transition: "0.3s",

								"&:hover": {
									transform: "translateY(-4px)",
									boxShadow:
										"0 0 35px rgba(0,255,136,0.6)",
								},
							}}
							onClick={() => window.open(gerarLinkWhatsApp("Regularizar minha situação fiscal!"), "_blank")}
						>
							Quero falar com a ContBlack →
						</Box>
					</Box>
				</Box>
			</Box>
			<Footer />
		</>
	);
}